import React from "react";
import Hero from "../components/Hero";
import FeaturedProducts from "../components/FeaturedProducts";
import MaterialsStrip from "../components/MaterialsStrip";
import SignatureCollections from "../components/SignatureCollections";
import AboutSection from "../components/AboutSection";
import CustomCta from "../components/CustomCta";
import InstagramFeed from "../components/InstagramFeed";
import ReviewsStrip from "../components/ReviewsStrip";
import SaleHeroBanner from "../components/SaleHeroBanner";
import SEO from "../components/SEO";

const HomePage = () => {
  return (
    <main>
      <SEO />
      <Hero />
      <SaleHeroBanner />
      <FeaturedProducts />
      <MaterialsStrip />
      <SignatureCollections />
      <AboutSection />
      <ReviewsStrip />
      <InstagramFeed />
      <CustomCta />
    </main>
  );
};

export default HomePage;
